import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalOptions, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-booking-approval-response-modal',
  templateUrl: './booking-approval-response-modal.component.html',
  styleUrls: ['./booking-approval-response-modal.component.scss']
})
export class BookingApprovalResponseModalComponent implements OnInit {
  public onClose: Subject<boolean>;
  requestStatus: any;
  requestId: any;
  approvalId: any;

  constructor(
    private options: ModalOptions,
    public bsModalRef: BsModalService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.requestStatus = this.options.initialState?.status
    this.requestId = this.options.initialState?.booking
    this.approvalId = this.options.initialState?.approval
    this.onClose = new Subject();
    if (this.requestStatus === 'Approved') {
      setTimeout(() => {

        this.router.navigateByUrl(`/corporate-account/approvals/payment/${this.requestId}`)
        this.bsModalRef?.hide();
      }, 1000);
    }
  }

  close() {
    this.bsModalRef?.hide();
    this.onClose.next(true);

  }

  

  viewBooking() {
    this.router.navigateByUrl(`/corporate-account/approvals/${this.requestId}`)
    this.bsModalRef?.hide();
  }

  viewBookingRejected() {
    this.router.navigateByUrl(`/corporate-account/approvals/${this.requestId}/${this.approvalId}`)
    this.bsModalRef?.hide();
  }

}
